module.exports = __webpack_public_path__ + "static/media/gogoro-logo-small.1a72b037.svg";